import React from 'react';
import { Link } from 'react-router-dom';
import type { ScreeningSummaryModelV1 } from '../../../lib/screeningSummary/types';
import { reportReaderPath, siteOverviewPath } from '../../../lib/siteNavigation';
export function SummaryToolbar({ model, siteId, pageSize: _pageSize, pending, onPageSize: _onPageSize, onDownload, intentDriftNotice, downloadError }: {
  model: ScreeningSummaryModelV1; siteId: string; pageSize?: 'A4' | 'Letter'; pending: boolean;
  onPageSize?: (size: 'A4' | 'Letter') => void; onDownload: () => void;
  intentDriftNotice?: string | null; downloadError?: string | null;
}) {
  const id = model.identity;
  return <>
    <nav className="toolbar print:hidden" data-screen-only-cta aria-label="Screening summary actions">
      <Link className="tb-back" to={siteOverviewPath(siteId, 'reports')}>‹ Analyses</Link>
      <div className="tb-title"><strong>Screening summary</strong><span>{id.siteName} · Report version {id.version.replace(/^v/i, '')} · Generated {id.screenedOn}</span></div>
      <div className="tb-actions">
        <Link className="btn" to={reportReaderPath(siteId, id.reportId)}>Open full report</Link>
        <button className="btn primary" disabled={pending} onClick={onDownload}>{pending ? 'Building PDF…' : 'Download PDF'}</button>
      </div>
    </nav>
    {intentDriftNotice && (
      <div
        className="print:hidden border-b border-amber-500/40 bg-amber-500/10 px-4 py-2 text-xs text-amber-950 dark:text-amber-200"
        role="status"
        data-testid="screening-summary-intent-drift"
        data-screen-only-cta
      >
        {intentDriftNotice}
      </div>
    )}
    {downloadError && (
      <div
        className="print:hidden border-b border-rose-500/40 bg-rose-500/10 px-4 py-2 text-xs text-rose-950 dark:text-rose-200"
        role="alert"
        data-testid="screening-summary-download-error"
        data-screen-only-cta
      >
        {downloadError}
      </div>
    )}
  </>;
}
